// extracted by mini-css-extract-plugin
export default {"event":"EventItem_event__SDyzx","actions":"EventItem_actions__tiW4A"};